var BranchesNearYouDataTestidEnum = /* @__PURE__ */ ((BranchesNearYouDataTestidEnum2) => {
  BranchesNearYouDataTestidEnum2["BRANCHES_LOCATION_BUTTON"] = "branches-location-button";
  BranchesNearYouDataTestidEnum2["BRANCHES_LIST"] = "branches-list";
  BranchesNearYouDataTestidEnum2["BRANCHES_LIST_LINK"] = "branches-list-link";
  BranchesNearYouDataTestidEnum2["BRANCHES_LIST_SCHEDULE_BUTTON"] = "branches-list-schedule-button";
  BranchesNearYouDataTestidEnum2["BRANCHES_LIST_DETAILS_BUTTON"] = "branches-list-details-button";
  BranchesNearYouDataTestidEnum2["BRANCHES_SHOW_MORE_BUTTON"] = "branches-show-more-button";
  return BranchesNearYouDataTestidEnum2;
})(BranchesNearYouDataTestidEnum || {});
export {
  BranchesNearYouDataTestidEnum
};
